<template src="./template.html"></template>
<style src="./styles.scss" lang="scss" scoped></style>

<script>
import { mapActions, mapState } from 'vuex'
import { mapFields } from 'vuex-map-fields'
import ClampList from '@/components/ui/ClampList'
import FallbackAvatar from '@/components/ui/FallbackAvatar'

export default {
  name: 'UserItem',
  components: {
    ClampList,
    FallbackAvatar,
  },
  props: {
    user: Object,
    occasion: Boolean,
  },
  data() {
    return {
      showMore: false,
      contentHeight: 0,
    }
  },
  computed: {
    ...mapFields('chat', [
      'conversationId',
      'isOpen',
      'selectedPanel',
    ]),
    ...mapState('users', ['userFieldIdentifiers']),
    ...mapState('auth', ['settings']),
    showControls() {
      return this.contentHeight > 100
    },
  },
  mounted() {
    this.setContentHeight()
  },
  methods: {
    ...mapActions('chat', ['chat']),
    async createUserConversation() {
      const chat = await this.chat()
      chat.createDirectMessageConversation([this.user.id]).then(({ data }) => {
        this.isOpen = true
        this.conversationId = data.conversation_id
        this.selectedPanel = 'ChatConversation'
      })
    },
    setContentHeight() {
      this.$nextTick(() => {
        if (this.$refs.content) {
          this.contentHeight = this.$refs.content.offsetHeight
          if (this.showControls) {
            this.showMore = true
          }
        }
      })
    },
  },
}
</script>
